if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        // Add clicked class to the parent elementclicked
        this.classList.add("clicked");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        let cartResponse; // Declare a variable to store the response

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            cartResponse = response; // Store the response here

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            // Call the function after the product has been added to the cart
            this.onProductAddedToCart(cartResponse.product_id);
            //console.log(formData);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            //console.log(cartResponse.product_id);
          });
      }

      onProductAddedToCart(variantid) {
        //console.log(variantid);

        const productId = variantid;

        // Check for the main product form on the PDP
        const mainForm = document.querySelector(
          "form[id^='product-form-template--']"
        );

        if (mainForm) {
          const formId = mainForm.getAttribute("id");
          //console.log(formId);
          let productIdInput = mainForm.querySelector(
            "input[name='product-id']"
          );
          productIdInput = productIdInput.value;
          if (productIdInput == productId) {
            //console.log(productIdInput, productId);
            this.addToCart(mainForm, variantid);
          }
        }

        // Iterate over all forms with IDs starting with 'quick-add-template--'
        document
          .querySelectorAll("form[id^='quick-add-']")
          .forEach((form) => {
            const formId = form.getAttribute("id");

            // //console.log(formId, variantid);

            if (formId.includes(variantid)) {
              //console.log("variantid", variantid);
              this.addToCart(form, variantid);
            } else if (formId.includes(productId)) {
              //console.log("productId", productId);

              this.addToCart(form, variantid);
            } else {
            }
          });
      }

      addToCart(currentElement, variantid) {
        //console.log('currentElement', currentElement);
        // Check if the clicked element has the 'clicked' class before creating the dot
      if (!currentElement.parentElement.classList.contains('clicked')) {
          //console.log("Variant was not clicked, dot won't be created.");
          return;
      }


        const dot = this.createCartDot(currentElement, variantid);

        if (!dot) return;

        document.body.append(dot);

        const rect = currentElement.getBoundingClientRect();
        dot.style.left = `${rect.left + window.scrollX}px`;
        dot.style.top = `${rect.top + window.scrollY}px`;

        this.moveDotToTarget(dot)
          .then(() => {
            dot.remove(); // Remove the dot after the animation is done
            currentElement.parentElement.classList.remove('clicked');
          });
      }

      moveDotToTarget(dot) {
        return new Promise((resolve) => {
          // const x = window.matchMedia("(max-width: 990px)");
          // const target = x.matches
          //   ? document.querySelector("li.bot-item.bot-cart")
          //   : document.querySelector("a#cart-icon-bubble");
          
          const target = document.querySelector("a#cart-icon-bubble");
          if (target) {
            const dotRect = dot.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();

            const translateX = targetRect.left - dotRect.left;
            const translateY = targetRect.top - dotRect.top;

            dot.style.transform = `translate(${translateX}px, ${translateY}px)`;
            dot.style.transition = "transform 01s ease";

            dot.addEventListener("transitionend", resolve, { once: true });
          } else {
            console.error("Target element not found for dot animation.");
            resolve();
          }
        });
      }

      createCartDot(currentElement, variantid) {
        const dot = document.createElement("div");
        dot.classList.add("product__dot");

        let imageUrl;

        if (currentElement.closest("li")) {
          const cardMedia = currentElement
            .closest("li")
            .querySelector(".card__media img");
          imageUrl = cardMedia ? cardMedia.src : "";

          //console.log(imageUrl);
        } else {
          const mainImage = document.querySelector("img.image-magnify-lightbox");
          imageUrl = mainImage ? mainImage.src : "";
        }

        if (imageUrl) {
          dot.style.backgroundImage = `url('${imageUrl}')`;
        } else {
          console.warn("Image URL not found, using default background color.");
          dot.style.backgroundColor = "#ff000000"; // Fallback color
        }

        dot.style.position = "absolute";
        dot.style.width = "50px";
        dot.style.height = "50px";
        dot.style.display = "block";
        dot.style.backgroundSize = "cover";
        dot.style.backgroundPosition = "center";
        dot.style.zIndex = "9999999999999999";

        return dot;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
